import {
  AWAITED_ACTION_LIST_SUCCESS,
  AWAITED_ACTION_LIST_ERROR,
  AWAITED_ACTION_LIST_START,
} from "../Constants/AwaitedListConstant";
const initialState = {
  awaitedLoading: false,
  data: [],
};

export default function AwaitedListReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case AWAITED_ACTION_LIST_START:
      return {
        ...state,
        data: [],
        awaitedLoading: true,
      };
    case AWAITED_ACTION_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        awaitedLoading: false,
      };
    case AWAITED_ACTION_LIST_ERROR:
      return {
        ...state,
        data: [],
        awaitedLoading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
